
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.d04c2edf.svg#" + id;
};
          